export default __webpack_public_path__ + "static/media/mobileBg.47b089b4.jpg";